/* =====================================================================
   PLAKTON · pk-menu.js
   Menú visual: empareja cada franja con su enlace de nivel 1 (por URL,
   o por texto como respaldo), la muestra al pasar el ratón y la coloca
   justo debajo de la cabecera (también cuando es fija). En móvil copia
   las tarjetas dentro del menú lateral.
   ===================================================================== */
(function () {
  'use strict';
  if (window.PKMenu) return;

  var OPEN_DELAY = 90, CLOSE_DELAY = 180;
  var openTimer = null, closeTimer = null, current = null;
  var desktop = window.matchMedia('(min-width: 1025px) and (hover: hover) and (pointer: fine)');

  function norm(path) {
    if (!path) return '';
    try { path = new URL(path, location.origin).pathname; } catch (e) { return ''; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root !== '/' && path.indexOf(root) === 0) path = '/' + path.slice(root.length);
    path = path.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '');
    return path.replace(/\/+$/, '').toLowerCase() || '/';
  }
  function key(str) { return String(str || '').trim().toLowerCase().replace(/[^a-z0-9À-ɏ]+/g, '-').replace(/^-|-$/g, ''); }

  function strips() { return Array.prototype.slice.call(document.querySelectorAll('[data-pk-strip]')); }

  function findStrip(link) {
    var list = strips();
    if (!list.length) return null;
    var href = norm(link.getAttribute('href'));
    var text = key(link.textContent);
    for (var i = 0; i < list.length; i++) {
      var p = norm(list[i].getAttribute('data-parent'));
      if (p && p !== '/' && p === href) return list[i];
    }
    for (var j = 0; j < list.length; j++) {
      var k = list[j].getAttribute('data-parent-key');
      if (k && k === text) return list[j];
    }
    return null;
  }

  function headerBottom(li) {
    var header = li.closest('.header-navigation, header, .shopify-section') || li;
    var r = header.getBoundingClientRect();
    return Math.max(0, Math.round(r.bottom));
  }

  function show(li, strip) {
    if (current && current.strip !== strip) hideNow();
    strip.hidden = false;
    strip.style.top = (headerBottom(li) + 10) + 'px';
    li.classList.add('is-pk-open');
    strip.querySelectorAll('.pk-menu__card').forEach(function (c, i) { c.style.setProperty('--pk-i', i); });
    window.requestAnimationFrame(function () { strip.classList.add('is-open'); });
    current = { li: li, strip: strip };
  }
  function hideNow() {
    if (!current) return;
    var c = current; current = null;
    c.li.classList.remove('is-pk-open');
    var navUl = c.li.parentNode; if (navUl && !navUl.matches(':hover')) navUl.classList.remove('pk-nav--pill');
    c.strip.classList.remove('is-open');
    setTimeout(function () { if (!c.strip.classList.contains('is-open')) c.strip.hidden = true; }, 260);
  }
  function scheduleHide() { clearTimeout(openTimer); clearTimeout(closeTimer); closeTimer = setTimeout(hideNow, CLOSE_DELAY); }
  function cancelHide() { clearTimeout(closeTimer); }

  function bind() {
    var items = document.querySelectorAll('.header__inline-menu .menu-lv-1');
    items.forEach(function (li) {
      if (li.dataset.pkMenu) return;
      var link = li.querySelector(':scope > a');
      if (!link) return;
      var strip = findStrip(link);
      if (!strip) return;
      li.dataset.pkMenu = '1';
      li.classList.add('pk-strip-parent');
      li.addEventListener('mouseenter', function () {
        if (!desktop.matches) return;
        cancelHide(); clearTimeout(openTimer);
        openTimer = setTimeout(function () { show(li, strip); }, OPEN_DELAY);
      });
      li.addEventListener('mouseleave', function () { if (desktop.matches) scheduleHide(); });
      link.addEventListener('focus', function () { if (desktop.matches) { cancelHide(); show(li, strip); } });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' && current && current.strip === strip) {
          e.preventDefault();
          var first = strip.querySelector('a');
          if (first) first.focus();
        }
      });
      strip.addEventListener('mouseenter', cancelHide);
      strip.addEventListener('mouseleave', scheduleHide);
      strip.addEventListener('focusout', function (e) {
        if (!strip.contains(e.relatedTarget) && e.relatedTarget !== link) scheduleHide();
      });
    });
  }

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && current) { var l = current.li.querySelector(':scope > a'); hideNow(); if (l) l.focus(); } });
  window.addEventListener('scroll', function () { if (current) hideNow(); }, { passive: true });
  window.addEventListener('resize', function () { if (current) current.strip.style.top = headerBottom(current.li) + 'px'; });
  document.addEventListener('click', function (e) {
    if (current && !current.strip.contains(e.target) && !current.li.contains(e.target)) hideNow();
  });

  /* ---------- Móvil: menú propio con pestañas (Mujer / Hombre / Niños) ---------- */
  function mobile() {
    var side = document.getElementById('navigation-mobile');
    if (!side || side.querySelector('.pk-mnav')) return;
    var list = strips();
    if (!list.length) return;
    var wrap = side.querySelector('.halo-sidebar-wrapper') || side;
    var nav = document.createElement('div');
    nav.className = 'pk-mnav';

    var tabs = document.createElement('div');
    tabs.className = 'pk-mnav__tabs';
    tabs.setAttribute('role', 'tablist');
    nav.appendChild(tabs);
    tabs.style.setProperty('--pk-tabs', list.length);
    tabs.style.setProperty('--pk-tab', 0);
    var thumb = document.createElement('span'); thumb.className = 'pk-mnav__thumb'; thumb.setAttribute('aria-hidden', 'true'); tabs.appendChild(thumb);

    list.forEach(function (strip, i) {
      var id = 'pk-mnav-panel-' + i;
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'pk-mnav__tab' + (i === 0 ? ' is-active' : '');
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      tab.setAttribute('aria-controls', id);
      tab.textContent = strip.getAttribute('data-title') || '';
      tabs.appendChild(tab);

      var panel = document.createElement('div');
      panel.className = 'pk-mnav__panel' + (strip.classList.contains('pk-menu__strip--soft') ? ' is-soft' : '');
      panel.id = id;
      panel.setAttribute('role', 'tabpanel');
      if (i !== 0) panel.hidden = true;
      var grid = document.createElement('div');
      grid.className = 'pk-mnav__grid';
      strip.querySelectorAll('.pk-menu__row > .pk-menu__card').forEach(function (card) {
        var c = card.cloneNode(true);
        c.removeAttribute('data-shopify-editor-block');
        c.querySelectorAll('br').forEach(function (br) { br.replaceWith(' '); });
        grid.appendChild(c);
      });
      Array.prototype.forEach.call(grid.children, function (c, k) { c.style.setProperty('--pk-i', k); });
      panel.appendChild(grid);
      var quick = strip.querySelector('.pk-menu__quick');
      if (quick) {
        var q = quick.cloneNode(true);
        q.className = 'pk-mnav__links';
        panel.appendChild(q);
      }
      nav.appendChild(panel);

      tab.addEventListener('click', function () {
        tabs.querySelectorAll('.pk-mnav__tab').forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        nav.querySelectorAll('.pk-mnav__panel').forEach(function (p) { p.hidden = true; });
        tab.classList.add('is-active'); tab.setAttribute('aria-selected', 'true'); panel.hidden = false;
        tabs.style.setProperty('--pk-tab', i);
      });
    });

    /* Enlaces de primer nivel sin franja (p. ej. Special prices) */
    var extra = [];
    document.querySelectorAll('#HeaderNavigation .menu-lv-1').forEach(function (li) {
      if (li.classList.contains('pk-strip-parent')) return;
      var a = li.querySelector(':scope > a[href]');
      if (a) extra.push({ href: a.getAttribute('href'), text: a.textContent.trim(), sale: li.classList.contains('menu-sale') });
    });
    if (extra.length) {
      var ul = document.createElement('ul');
      ul.className = 'pk-mnav__extra';
      extra.forEach(function (x) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = x.href; a.textContent = x.text; if (x.sale) a.className = 'is-sale';
        li.appendChild(a); ul.appendChild(li);
      });
      nav.appendChild(ul);
    }

    var anchor = wrap.querySelector('[data-navigation-mobile]');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(nav, anchor.nextSibling); else wrap.insertBefore(nav, wrap.firstChild);
    side.classList.add('pk-mnav-on');
  }

  /* ---------- Indicador deslizante bajo el menú (escritorio) ---------- */
  function pill() {
    var ul = document.querySelector('#HeaderNavigation .header__inline-menu > ul');
    if (!ul || ul.querySelector('.pk-nav-pill')) return;
    ul.classList.add('pk-nav');
    var p = document.createElement('span');
    p.className = 'pk-nav-pill';
    p.setAttribute('aria-hidden', 'true');
    ul.appendChild(p);
    function moveTo(li) {
      var a = li && li.querySelector(':scope > a');
      if (!a) { ul.classList.remove('pk-nav--pill'); return; }
      var r = a.getBoundingClientRect(), ur = ul.getBoundingClientRect();
      p.style.width = r.width + 'px';
      p.style.height = r.height + 'px';
      p.style.transform = 'translate(' + (r.left - ur.left) + 'px, ' + (r.top - ur.top) + 'px)';
      ul.classList.add('pk-nav--pill');
    }
    ul.querySelectorAll(':scope > .menu-lv-1').forEach(function (li) {
      li.addEventListener('mouseenter', function () { moveTo(li); });
      li.addEventListener('focusin', function () { moveTo(li); });
    });
    ul.addEventListener('mouseleave', function () { setTimeout(function () { if (!current) ul.classList.remove('pk-nav--pill'); else moveTo(current.li); }, 60); });
  }

  function init() { bind(); pill(); mobile(); }
  document.addEventListener('click', function (e) { if (e.target.closest('[data-mobile-menu], .mobileMenu-toggle, [data-menu-mobile]')) setTimeout(mobile, 30); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });

  window.PKMenu = { refresh: init, close: hideNow };
})();
